import {
  UserType,
  ProjectType,
  UserRoleEnumType,
  UserProjectOrganizationTypeEnumType,
} from '~/common/types/graphql'
import dateHelpers from '~/utils/dates'

export const projectHelpers = {
  // TODO: can this be done on API level alongside currentUserProjectContext?
  currentUserProjectContextRole: (
    context: string,
    role: UserType['role'],
  ): UserRoleEnumType => {
    let contextualRole = role
    if (
      (role === UserRoleEnumType.Admin ||
        role === UserRoleEnumType.Manager ||
        role === UserRoleEnumType.Guide) &&
      (context === UserProjectOrganizationTypeEnumType.ThirdParty ||
        context === UserProjectOrganizationTypeEnumType.Customer)
    ) {
      contextualRole = UserRoleEnumType.Contributor
    }

    return contextualRole || UserRoleEnumType.Contributor
  },

  getTimeElapsed: (
    project?: Pick<ProjectType, 'completedAt' | 'startOn'>,
  ): number => {
    const completedAt = project?.completedAt ? project.completedAt : new Date()

    return dateHelpers.calendarDaysDiff(project?.startOn, completedAt)
  },
}
